import Base from 'app/models/base';
import { appUrl } from 'utils/wrappers';

export default Base.extend({
  urlRoot: appUrl('labels'),
});



// WEBPACK FOOTER //
// ./app/models/label.js